import {
  gql 
} from "@apollo/client"

export const GET_STORE_CONFIG = gql`
    query getStoreConfig {
        storeConfig {
            store_code
            product_url_suffix
            grid_per_page
            weight_unit
        }
    }
`
